export enum RelativeDates {
    Today = "Today",
    Yesterday = "Yesterday",
    Last7Days = "Last7Days",
    Last14Days = "Last14Days",
    Last30Days = "Last30Days",
    LastWeek = "LastWeek",
    LastMonth = "LastMonth",
    WeekToDate = "WeekToDate",
    MonthToDate = "MonthToDate",
}
export type RelativeDateInfo = {
    name: RelativeDates;
    formatedName: string;
    startDate: Date;
    endDate: Date;
};

export const TIME_RANGE_TOOLTIP = "Please enter a valid time range.";

export const MAX_HOURS = 23;
export const MAX_MINUTES_OR_SECONDS = 59;
export const MAX_MILLISECONDS = 999;
